<template>
	<scale-text-field
		class="textfield"
		type="text"
		:value="props.value"
		@input="updateValue"
		:label="props.label"
		:placeholder="props.placeholder"
		:helper-text="props.helperText"
		:invalid="props.invalid"
		:max-length="props.maxLength"
		:counter="props.counter"
	>
		<slot name="tooltip-info"></slot>
	</scale-text-field>
</template>

<script setup>
  import { defineProps, defineEmits } from 'vue';

  // Define props
  const props = defineProps({
    value: String,
    label: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      required: false,
      default: ''
    },
    helperText: {
      type: String,
      required: false,
      default: ''
    },
    invalid: {
      type: Boolean,
      required: false,
      default: false
    },
    maxLength: {
      type: Number,
      required: false
    },
    counter: {
      type: Boolean,
      required: false,
      default: false
    }
  });

  // Define emits
  const emit = defineEmits(['input']);

  // Method to emit the input event
  const updateValue = (event) => {
    emit('input', event.target.value);
  };
</script>

<style lang="scss" scoped>
.textfield {
  position: relative;
  display: block;
}

.tooltip {
  position: absolute;
  z-index: 2;
  right: 6px;
  top: 10px;
}

.tooltip-icon:hover {
  cursor: pointer;
}
</style>
